import axios, { AxiosResponse } from 'axios';

export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true
});

const csrfCookie = document.cookie
  .split('; ')
  .find((cookie) => cookie.startsWith('XSRF-TOKEN='));

export const csrfToken = csrfCookie
  ? decodeURIComponent(csrfCookie.split('=')[1])
  : null;

export const getCsrfToken = async () => {
  await instance.get('/sanctum/csrf-cookie');
};

// 初回アクセスでCSRFトークンを取得するための関数
export const getCsrfTokenOnCookie = async () => {
  try {
    await instance.get('/sanctum/csrf-cookie');

    const csrfCookie = document.cookie
      .split('; ')
      .find((cookie) => cookie.startsWith('XSRF-TOKEN='));

    return csrfCookie ? decodeURIComponent(csrfCookie.split('=')[1]) : null;
  } catch (err) {
    return null;
  }
};

export const getCsrfTokenResponse = async (): Promise<
  AxiosResponse<{ status: string }>
> => {
  return await instance.get('/sanctum/csrf-cookie');
};

export interface response extends AxiosResponse {
  data: {
    message: string;
  };
}
